module.exports = __webpack_public_path__ + "media/images/ohap_help icon_40x40 test-a9f9ea471ceb9dd014889060e77fd5c1.png";